// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getTiposVisitantes as listTiposVisitantesAPI,
    getTiposVisitante as getTiposVisitanteAPI,
    addTiposVisitante as addTiposVisitanteAPI,
    updateTiposVisitante as updateTiposVisitanteAPI,
    deleteTiposVisitante as deleteTiposVisitanteAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { tiposVisitantesApiResponseError, tiposVisitantesApiResponseSuccess } from './actions';
import { TiposVisitantesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getTiposVisitante({ payload: { id } }) {
    try {
        const response = yield call(getTiposVisitanteAPI, id );
        const tiposVisitanteItem = response.data.data;
        yield put(tiposVisitantesApiResponseSuccess(TiposVisitantesActionTypes.GET_TIPO, tiposVisitanteItem));
    } catch (error) {
        yield put(tiposVisitantesApiResponseError(TiposVisitantesActionTypes.GET_TIPO, error));
    }
}

function* addTiposVisitante({payload:tiposVisitante}){
    try{
        const response = yield call(addTiposVisitanteAPI,{...tiposVisitante})
        const tiposVisitanteItem = response.data.data
        yield put(tiposVisitantesApiResponseSuccess(TiposVisitantesActionTypes.ADD_TIPO,tiposVisitanteItem))
    } catch(error){
        yield put(tiposVisitantesApiResponseError(TiposVisitantesActionTypes.ADD_TIPO,error))
    }
}

function* updateTiposVisitante({payload:tiposVisitante}){
    try{
        const response = yield call(updateTiposVisitanteAPI,{...tiposVisitante})
        const tiposVisitanteItem = response.data.data
        yield put(tiposVisitantesApiResponseSuccess(TiposVisitantesActionTypes.UPDATE_TIPO,tiposVisitanteItem))
    }catch(error){
        yield put(tiposVisitantesApiResponseError(TiposVisitantesActionTypes.UPDATE_TIPO,error))
    }
}
function* deleteTiposVisitante({payload:{id}}){
    try{
        const response = yield call(deleteTiposVisitanteAPI,id)
        const tiposVisitanteItem = response.data.id
        yield put(tiposVisitantesApiResponseSuccess(TiposVisitantesActionTypes.DELETE_TIPO,tiposVisitanteItem))
    }catch(error){
        yield put(tiposVisitantesApiResponseError(TiposVisitantesActionTypes.DELETE_TIPO,error))
    }
}

/**
 * List contactos
 */
function* listTiposVisitantes({payload:params}) {
    try {
        const response = yield call(listTiposVisitantesAPI, { ...params });
        const listaTiposVisitantes = response.data.data;
        yield put(tiposVisitantesApiResponseSuccess(TiposVisitantesActionTypes.LIST_TIPOS, listaTiposVisitantes));
    } catch (error) {
        yield put(tiposVisitantesApiResponseError(TiposVisitantesActionTypes.LIST_TIPOS, error));
    }
}


export function* watchGetTiposVisitante(): any {
    yield takeEvery(TiposVisitantesActionTypes.GET_TIPO, getTiposVisitante);
}

export function* watchListTiposVisitantes(): any {
    yield takeEvery(TiposVisitantesActionTypes.LIST_TIPOS, listTiposVisitantes);
}

export function* watchAddTiposVisitante():any{
    yield takeEvery(TiposVisitantesActionTypes.ADD_TIPO,addTiposVisitante)
}
export function* watchUpdateTiposVisitante():any{
    yield takeEvery(TiposVisitantesActionTypes.UPDATE_TIPO,updateTiposVisitante)
}
export function* watchDeleteTiposVisitante():any{
    yield takeEvery(TiposVisitantesActionTypes.DELETE_TIPO,deleteTiposVisitante)
}


function* tiposVisitantesSaga(): any {
    yield all([
        fork(watchGetTiposVisitante),
        fork(watchListTiposVisitantes),
        fork(watchAddTiposVisitante),
        fork(watchUpdateTiposVisitante),
        fork(watchDeleteTiposVisitante),
    ]);
}

export default tiposVisitantesSaga;
